import { SvgStyled } from '../../components/Global/Atomics/SvgStyled';

const Car_xl = (props) => {
    const width = props.width ? props.width + 'px' : '40px';
    const height = props.height ? props.height + 'px' : '40px';

    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 40 40"
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={width}
            height={height}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.5387 9.51553C11.7761 8.06496 13.0295 7 14.4993 7H25.5007C26.9705 7 28.2239 8.06496 28.4613 9.51553L29.8497 18H31C32.6569 18 34 19.3431 34 21V27C34 28.3113 33.1586 29.4262 31.9863 29.8341C31.9953 29.8881 32 29.9435 32 30V32C32 33.6569 30.6569 35 29 35C27.3432 35 26 33.657 26 32.0001V30H14V32C14 33.6569 12.6569 35 11 35C9.3432 35 8 33.657 8 32.0001V30C8 29.9435 8.00469 29.8881 8.0137 29.8341C6.84136 29.4262 6 28.3113 6 27V21C6 19.3431 7.34315 18 9 18H10.1503L11.5387 9.51553ZM12.1769 18H27.8231L26.4875 9.83851C26.4084 9.35499 25.9906 9 25.5007 9H14.4993C14.0094 9 13.5916 9.35499 13.5125 9.83851L12.1769 18ZM9 20C8.44772 20 8 20.4477 8 21V27C8 27.5523 8.44772 28 9 28H31C31.5523 28 32 27.5523 32 27V21C32 20.4477 31.5523 20 31 20H9ZM10 30V32.0001C10 32.5523 10.4477 33 11 33C11.5523 33 12 32.5523 12 32V30H10ZM28 30V32.0001C28 32.5523 28.4477 33 29 33C29.5523 33 30 32.5523 30 32V30H28Z"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.5 23.75C12.0858 23.75 11.75 24.0858 11.75 24.5C11.75 24.9142 12.0858 25.25 12.5 25.25C12.9142 25.25 13.25 24.9142 13.25 24.5C13.25 24.0858 12.9142 23.75 12.5 23.75ZM10.25 24.5C10.25 23.2574 11.2574 22.25 12.5 22.25C13.7426 22.25 14.75 23.2574 14.75 24.5C14.75 25.7426 13.7426 26.75 12.5 26.75C11.2574 26.75 10.25 25.7426 10.25 24.5ZM27.5 23.75C27.0858 23.75 26.75 24.0858 26.75 24.5C26.75 24.9142 27.0858 25.25 27.5 25.25C27.9142 25.25 28.25 24.9142 28.25 24.5C28.25 24.0858 27.9142 23.75 27.5 23.75ZM25.25 24.5C25.25 23.2574 26.2574 22.25 27.5 22.25C28.7426 22.25 29.75 23.2574 29.75 24.5C29.75 25.7426 28.7426 26.75 27.5 26.75C26.2574 26.75 25.25 25.7426 25.25 24.5ZM17.25 25C17.25 24.5858 17.5858 24.25 18 24.25H22C22.4142 24.25 22.75 24.5858 22.75 25C22.75 25.4142 22.4142 25.75 22 25.75H18C17.5858 25.75 17.25 25.4142 17.25 25Z"
            />
        </SvgStyled>
    );
};

export default Car_xl;
